import { addDoc, collection, deleteDoc, doc, orderBy, query, serverTimestamp, getDocs, setDoc } from "firebase/firestore";
import { auth, db } from "./firebase";

export interface SavedExplanation {
  id: string;
  questionId?: string;
  examId?: string;
  subject?: string;
  topic?: string;
  statement?: string;
  explanation: string;
  source?: "question" | "flashcard";
  optionChosen?: string;
  createdAt?: any;
}

const getCollectionRef = (uid: string) => collection(db, "users", uid, "savedExplanations");

export const saveExplanation = async (payload: Omit<SavedExplanation, "id">): Promise<string> => {
  const user = auth.currentUser;
  if (!user) throw new Error("É necessário estar logado para salvar explicações.");

  const baseData = {
    ...payload,
    createdAt: serverTimestamp(),
  } as any;

  // Se tiver questionId, usamos como chave para evitar duplicados; senão, gera autoId
  if (payload.questionId) {
    const docRef = doc(db, "users", user.uid, "savedExplanations", String(payload.questionId));
    await setDoc(docRef, baseData, { merge: true });
    return docRef.id;
  }

  const ref = await addDoc(getCollectionRef(user.uid), baseData);
  return ref.id;
};

export const listSavedExplanations = async (): Promise<SavedExplanation[]> => {
  const user = auth.currentUser;
  if (!user) return [];

  const q = query(getCollectionRef(user.uid), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) }));
};

export const removeSavedExplanation = async (id: string): Promise<void> => {
  const user = auth.currentUser;
  if (!user) return;
  await deleteDoc(doc(db, "users", user.uid, "savedExplanations", id));
};
